import type { RosterRow } from './rosterRows';

export function scopeByEnrollment(rows: RosterRow[], includeDeparted: boolean): RosterRow[] {
  return includeDeparted ? rows : rows.filter((row) => row.enrollment !== 'departed');
}

export function departedEmptyState(rows: RosterRow[], includeDeparted: boolean): boolean {
  return (
    !includeDeparted && rows.length > 0 && rows.every((row) => row.enrollment === 'departed')
  );
}
